import { createFileRoute, redirect } from '@tanstack/react-router';
import { sessionQuery } from '@/lib/use-session';

// Landing route. Authed users → /feed, unauthed → /auth/login.
// Mirrors the old Next `resolveLandingPath()` server helper.
//
// We isolate the `ensureQueryData` call inside its own try — that way a
// genuine fetch error (network down, server 500) routes to /auth/login,
// but the `throw redirect(...)` below escapes the try entirely and is
// handled by TanStack Router itself. (Catching the redirect was the
// migration's first big bug: redirect() returns a `Response` instance,
// not `{ isRedirect: true }`, so a naive instanceof-less catch swallowed
// it and bounced everyone back to login.)
export const Route = createFileRoute('/')({
  beforeLoad: async ({ context }) => {
    let data;
    try {
      data = await context.queryClient.ensureQueryData(sessionQuery);
    } catch {
      throw redirect({ to: '/auth/login' });
    }
    throw redirect({ to: data !== null ? '/feed' : '/auth/login' });
  },
});
